import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <main
        className="flex-1 overflow-auto transition-all duration-200"
        style={{ marginLeft: collapsed ? 64 : 256 }}
      >
        <Outlet />
      </main>
    </div>
  );
}
